import { IconListProps } from '../../reusable';

const listItems: IconListProps['listItems'] = [
  {
    icon: 'NotesMedical',
    text: 'Help you understand your symptoms and provide a diagnosis',
    color: 'info',
    styleType: 'duotone',
  },
  {
    icon: 'Prescription',
    text: 'Prescribe medication while providing supporting therapy',
    color: 'success',
    styleType: 'duotone',
  },
  {
    icon: 'ClipboardMedical',
    text: 'Personalize a treatment plan just for you',
    color: 'error',
    styleType: 'duotone',
  },
];

export default listItems;
